module.exports = __webpack_public_path__ + "img/green-carpet-grass-11.f8fabe6f.png";